import { inject, NgModule } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { BibitemComponent } from './bibitem/bibitem.component';
import { LoginComponent } from './member/login/login.component';
import { ResultsComponent } from './results/results.component';
import { SubcategoryComponent } from './category/subcategory/subcategory.component';
import { CategoryComponent } from './category/category/category.component';
import { VersionComponent } from './version/version.component';
import { AboutusComponent } from './aboutus/aboutus.component';
import { ContactusComponent } from './contactus/contactus.component';
import { RegulationComponent } from './regulation/regulation.component';
import { VirtualbookshelfComponent } from './virtualbookshelf/virtualbookshelf.component';
import { NewListComponent } from './news/new-list/new-list.component';
import { NewsDetailComponent } from './news/news-detail/news-detail.component';
import { ExportSaveComponent } from './export-save/export-save.component';
import { BookshelfdiscoveryComponent } from './bookshelfdiscovery/bookshelfdiscovery.component';
import { CookiepolicySettingComponent } from './admin/setting/cookiepolicy-setting/cookiepolicy-setting.component';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import { PageAnnouncementComponent } from './page-announcement/page-announcement.component';
import { SsoComponent } from './member/sso/sso.component';
import { LegacyBibitemredirectComponent } from './bibitem/legacy-bibitemredirect/legacy-bibitemredirect.component';
const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'login', component: LoginComponent },
  { path: 'kku-sso', component: SsoComponent },
  { path: 'sso', component: SsoComponent },
  {
    path: 'catalog/BibItem.aspx', // Matches the old path
    resolve: {
      redirect: (activatedRouteSnapshot) => {
        const router = inject(Router);
        const oldBibId = activatedRouteSnapshot.queryParams['BibID'];

        if (oldBibId) {
          // Navigate to the new URL with the correct query parameter name
          router.navigate(['/bibitem'], {
            queryParams: { bibid: oldBibId },
          });
        } else {
          // Navigate to home page if BibID is missing
          router.navigate(['/home']);
        }
      },
    },
  },
  {
    path: 'Catalog/BibItem.aspx', // Matches the old path with Capital 'C'
    resolve: {
      redirect: (activatedRouteSnapshot) => {
        const router = inject(Router);
        const oldBibId = activatedRouteSnapshot.queryParams['BibID'];

        if (oldBibId) {
          // Navigate to the new URL with the correct query parameter name
          router.navigate(['/bibitem'], {
            queryParams: { bibid: oldBibId },
          });
        } else {
          // Navigate to home page if BibID is missing
          router.navigate(['/home']);
        }
      },
    },
  },
  // {
  //   path: 'catalog/BibItem.aspx',
  //   component: LegacyBibitemredirectComponent
  // },
  { path: 'bibitem', component: BibitemComponent },
  { path: 'export', component: ExportSaveComponent },
  { path: 'category', component: CategoryComponent },
  { path: 'subcategory', component: SubcategoryComponent },
  { path: 'version', component: VersionComponent },
  { path: 'aboutus', component: AboutusComponent },
  { path: 'contactus', component: ContactusComponent },
  { path: 'regulation', component: RegulationComponent },
  { path: 'virtualbookshelf/:itemid', component: VirtualbookshelfComponent },
  { path: 'bookshelfdiscovery', component: BookshelfdiscoveryComponent },
  { path: 'results', component: ResultsComponent },
  { path: 'member', loadChildren: () => import('./member/member.module').then(m => m.MemberModule) },
  { path: 'search', loadChildren: () => import('./search/search.module').then(m => m.SearchModule) },
  { path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule) },
  { path: 'news', component: NewListComponent },
  { path: 'newsdetail/:id', component: NewsDetailComponent },
  { path: 'policy', component: CookiepolicySettingComponent },
  { path: 'announce', pathMatch: 'full', component: PageAnnouncementComponent },
  // Wild Card Route for 404 request
  { path: '**', pathMatch: 'full', component: PagenotfoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
